<div class="auth-page-wrapper">

    <!-- Background -->
    <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div class="bg-overlay"></div>
        <div class="shape">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120">
                <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
        </div>
    </div>

    <!-- CONTENT -->
    <div class="auth-page-content">
        <div class="container-fluid h-100 p-0">

            <div class="row justify-content-center h-100 m-0">
                <div class="col-md-8 col-lg-6 col-xl-5 h-100 p-1 d-flex flex-column">

                    <!-- ✅ HEADER (FIXED INSIDE LAYOUT) -->
                    <div class="text-center text-white-50">
                        <p class="fs-15 fw-medium mb-1" style="color: yellow;">
                            Visitor Management System
                        </p>
                        <p class="fs-18 fw-bolder mb-1" style="color: yellow;">
                            {{appservice.Company_Name}}
                        </p>
                    </div>

                    <!-- ✅ CARD 1 -->
                    <div class="card card-bg-fill">

                        <div class="text-center mt-1">
                            <h5 class="text-primary">VISITOR</h5>
                        </div>

                        <div class="card-body">

                            <div class="text-center mb-1">
                                <img class="custom-img"
                                     src="{{appservice.Server_URL}}/image/V{{appservice.Company_}}/V{{add.Contact_No}}.png"
                                     (error)="img.src='../../assets/img/user-dummy-img.jpg'" #img />
                            </div>

                            <!-- DETAILS -->
                            <div class="row mb-1" *ngFor="let item of [
                                {label:'Name', value:add.Visitor_Name + ' ' + add.Last_Name},
                                {label:'Company', value:add.Company_Name},
                                {label:'Purpose', value:add.Purpose},
                                {label:'Meeting', value:add.V_Person},
                                {label:'Visitor ID', value:add.Barcode},
                                {label:'Laptop', value:add.Laptop_Permit},
                                {label:'Created', value:add.Created_Date}
                            ]">
                                <div class="col-5 text-end">{{item.label}}</div>
                                <div class="col-1 text-center">:</div>
                                <div class="col-6 text-start">{{item.value}}</div>
                            </div>

                            <!-- STATUS -->
                            <div class="text-center mt-1"
                                [ngClass]="{
                                    'status-waiting': add.Approval_Status === statusEnum.WAITING,
                                    'status-approved': add.Approval_Status === statusEnum.APPROVED,
                                    'status-cancelled': add.Approval_Status === statusEnum.CANCELLED
                                }">

                                <span *ngIf="add.Approval_Status === statusEnum.APPROVED">
                                    {{ add.Approval_Status }} ✔
                                </span>

                                <span *ngIf="add.Approval_Status === statusEnum.CANCELLED">
                                    {{ add.Approval_Status }} ✖
                                </span>

                                <span *ngIf="add.Approval_Status === statusEnum.WAITING">
                                    {{ add.Approval_Status }}
                                </span>
                            </div>

                            <!-- REASON -->
                            <div class="row mt-1" *ngIf="add.Approval_Status === statusEnum.CANCELLED">
                                <div class="col-5 text-end">Reason</div>
                                <div class="col-1 text-center">:</div>
                                <div class="col-6 text-start">{{add.Approval_Remarks}}</div>
                            </div>

                        </div>
                    </div>

                    <!-- ✅ CARD 2 -->
                    <div class="card card-bg-fill">

                        <div class="text-center mt-1">
                            <img class="image" src="../../assets/img/s.jpg" />
                        </div>

                        <div class="welcome-text">
                            {{ Welcome_Message }}
                        </div>

                    </div>

                </div>
            </div>

        </div>
    </div>
</div>